import PropTypes from "prop-types";
import { getMediaFileName } from "../../media/utils/mediaUtils.js";

import Modal from '../../../components/Modal';
import { useModal } from '../../../hooks/useModal';
import Button from '../../../components/Button';
import { galleryShell } from "../../../styles/galleryShell";

function renderMediaContent(item, name) {
    switch (item.media_type) {
        case "image":
            return <img src={item.url} alt={name} className={galleryShell.media} />;
        case "video":
            return <video src={item.url} controls className={galleryShell.media} />;
        case "audio":
            return <audio src={item.url} controls className={galleryShell.mediaAudio} />;
        default:
            return (
                <div className={galleryShell.mediaError}>
                    <p>サポートされていないメディアタイプ: {item.media_type}</p>
                </div>
            );
    }
}

function GalleryMediaItem({ item, onDelete }) {
    const { isOpen, openModal, closeModal } = useModal();

    if (!item) {
        return (
            <div className={galleryShell.mediaError}>
                <p>メディアデータが無効です</p>
            </div>
        );
    }

    const name = getMediaFileName(item);

    const handleDelete = (e) => {
        e.stopPropagation();
        openModal();
    };

    const handleConfirmDelete = () => {
        closeModal();
        onDelete(item.id);
    };

    return (
        <>
            <div className={galleryShell.item}>
                {renderMediaContent(item, name)}

                {onDelete && (
                    <Button
                        variant="danger"
                        size="sm"
                        className={galleryShell.deleteButton}
                        onClick={handleDelete}
                        aria-label={`${name}を削除`}
                        title={`${name}を削除`}
                    >
                        <span className="material-symbols-outlined">
                            delete
                        </span>
                    </Button>
                )}
            </div>

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title="このメディアを削除しますか？"
                size="small"
                actions={[
                    { label: "キャンセル", variant: "secondary" },
                    { label: "削除", variant: "danger", onClick: handleConfirmDelete }
                ]}
            >
                <p style={{ textAlign: 'center', margin: 0 }}>この操作は取り消せません。</p>
            </Modal>
        </>
    );
}

GalleryMediaItem.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        url: PropTypes.string.isRequired,
        media_type: PropTypes.oneOf(["image", "video", "audio"]).isRequired,
        filename: PropTypes.string,
        name: PropTypes.string
    }).isRequired,
    onDelete: PropTypes.func
};

export default GalleryMediaItem;
